import { post, fetch, patch, put, postJson } from '../../http'
export default {
  //创建账号
  createAccount(params) {
    return post('/Personnel/Config/createAccount', params)
  },
}
